import { AnyAction, Reducer } from 'redux';
import {
  ADD_CONTAINER,
  ADD_CONTAINER_LOCATION,
  ADD_DEPLOYMENT_PROFILE_INLINE,
  ADD_LOCATION_TO_REGION,
  ADD_REGION,
  ADD_REGION_IS_ERROR,
  ADD_REGION_IS_PENDING,
  CANCEL_DELETE_CONTAINER,
  CANCEL_DELETE_CONTAINER_IS_ERROR,
  CANCEL_DELETE_CONTAINER_IS_PENDING,
  CANCEL_DELETE_DEPLOYMENT_PROFILE,
  CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_ERROR,
  CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_PENDING,
  CANCEL_DELETE_LOCATION,
  CANCEL_DELETE_LOCATION_IS_ERROR,
  CANCEL_DELETE_LOCATION_IS_PENDING,
  CANCEL_DELETE_REGION,
  CANCEL_DELETE_REGION_IS_ERROR,
  CANCEL_DELETE_REGION_IS_PENDING,
  CANCEL_EDITION_INLINE,
  CANCEL_LOCATION_FROM_CONTAINER,
  CANCEL_LOCATION_TO_REGION,
  CANCEL_REGION_INLINE_EDITION,
  CANCEL_REGION_LOCAL_CHANGE,
  CLEAN_ERROR,
  CREATE_DEPLOYMENT_PROFILE,
  CREATE_DEPLOYMENT_PROFILE_IS_ERROR,
  CREATE_DEPLOYMENT_PROFILE_IS_PENDING,
  DELETE_CONTAINER,
  DELETE_CONTAINER_IS_ERROR,
  DELETE_CONTAINER_IS_PENDING,
  DELETE_DEPLOYMENT_PROFILE,
  DELETE_DEPLOYMENT_PROFILE_IS_ERROR,
  DELETE_DEPLOYMENT_PROFILE_IS_PENDING,
  DELETE_LOCATION,
  DELETE_LOCATION_IS_ERROR,
  DELETE_LOCATION_IS_PENDING,
  DELETE_REGION,
  DELETE_REGION_IS_PENDING,
  DEPLOYMENT_PROFILE_CANCEL_LOCAL_CHANGES,
  DEPLOYMENT_PROFILE_LOCAL_CHANGE,
  FETCH_DEPLOYMENT_PROFILE,
  FETCH_DEPLOYMENT_PROFILE_BY_ID,
  FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_ERROR,
  FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_PENDING,
  FETCH_DEPLOYMENT_PROFILE_IS_ERROR,
  FETCH_DEPLOYMENT_PROFILE_IS_PENDING,
  FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES,
  FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR,
  FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING,
  FETCH_REGION_BY_ID,
  FETCH_REGION_BY_ID_IS_ERROR,
  FETCH_REGION_BY_ID_IS_PENDING,
  REGION_LOCAL_CHANGE,
  REMOVE_LOCATION_FROM_REGION,
  SAVE_CONTAINER_LOCATION,
  SORT,
  SORT_REGIONS,
  UPDATE_DEPLOYMENT_PROFILE,
  UPDATE_DEPLOYMENT_PROFILE_IS_ERROR,
  UPDATE_DEPLOYMENT_PROFILE_IS_PENDING,
  UPDATE_REGION,
  UPDATE_REGION_IS_ERROR,
  UPDATE_REGION_IS_PENDING,
} from 'services/GameHosting/DeploymentProf/types';
import { addNew, parseError, sort } from 'utils/functions';

const INITIAL_STATE = {
  sortBy: 'name',
  sortDirection: 'ASC',
  sortRegionBy: 'name',
  sortRegionDirection: 'ASC',

  depProfOriginal: {},
  regionOriginal: {},

  RegionProperties: [],
};

const CRUD_PROPERTIES = {
  depProfs: [],
  depProf: {},

  region: {},

  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,

  addIsCompleted: false,
  addIsPending: false,
  addIsError: null,

  editIsCompleted: false,
  editIsPending: false,
  editIsError: null,

  deleteIsCompleted: false,
  deleteIsPending: false,
  deleteIsError: null,

  cancelDeleteIsCompleted: false,
  cancelDeleteIsPending: false,
  cancelDeleteIsError: null,

  fetchByIdIsCompleted: false,
  fetchByIdIsPending: false,
  fetchByIdIsError: null,

  addRegionIsCompleted: false,
  addRegionIsPending: false,
  addRegionIsError: null,

  regionPropertiesIsCompleted: false,
  regionPropertiesIsPending: false,
  regionPropertiesIsError: null,

  editRegionIsCompleted: false,
  editRegionIsPending: false,
  editRegionIsError: null,

  deleteRegionIsCompleted: false,
  deleteRegionIsPending: false,
  deleteRegionIsError: null,

  cancelDeleteRegionIsCompleted: false,
  cancelDeleteRegionIsPending: false,
  cancelDeleteRegionIsError: null,

  fetchRegionByIdIsCompleted: false,
  fetchRegionByIdIsPending: false,
  fetchRegionByIdIsError: null,

  deleteContainerIsCompleted: false,
  deleteContainerIsPending: false,
  deleteContainerIsError: null,

  cancelDeleteContainerIsCompleted: false,
  cancelDeleteContainerIsPending: false,
  cancelDeleteContainerIsError: null,

  deleteLocationIsCompleted: false,
  deleteLocationIsPending: false,
  deleteLocationIsError: null,

  cancelDeleteLocationIsCompleted: false,
  cancelDeleteLocationIsPending: false,
  cancelDeleteLocationIsError: null,
};

const defaultState = {
  ...INITIAL_STATE,
  ...CRUD_PROPERTIES,
};

// TODO FIXME
// eslint-disable-next-line @typescript-eslint/default-param-last
const deploymentProfileReducer: Reducer<$TSFixMe, AnyAction> = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_DEPLOYMENT_PROFILE:
      return {
        ...state,
        depProfs: sort(action.depProfs, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_DEPLOYMENT_PROFILE_BY_ID:
      // NOTE: There is a depProfOriginal variable in order to allow local changes using reducer and cancel them
      return {
        ...state,
        depProf: {
          ...action.depProf,
          deploymentRegions: sort(action.depProf.deploymentRegions, {
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            sortBy: state.sortRegionBy,
            sortDirection: state.sortRegionDirection,
          }),
        },
        depProfOriginal: { ...action.depProf },
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: null,
      };
    case FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchByIdIsCompleted: false,
        fetchByIdIsPending: true,
        fetchByIdIsError: null,
      };
    case FETCH_DEPLOYMENT_PROFILE_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: action.error,
      };

    case FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES:
      return {
        ...state,
        RegionProperties: action.data,
        regionPropertiesIsCompleted: true,
        regionPropertiesIsPending: false,
        regionPropertiesIsError: null,
      };
    case FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_PENDING:
      return {
        ...state,
        regionPropertiesIsCompleted: false,
        regionPropertiesIsPending: true,
        regionPropertiesIsError: null,
      };
    case FETCH_DEPLOYMENT_PROFILE_REGION_PROPERTIES_IS_ERROR:
      return {
        ...state,
        regionPropertiesIsCompleted: true,
        regionPropertiesIsPending: false,
        regionPropertiesIsError: action.error,
      };

    case CREATE_DEPLOYMENT_PROFILE:
      return {
        ...state,
        depProfs: addNew(action.depProf, state.depProfs),
        addIsCompleted: true,
        addIsPending: false,
        addIsError: null,
      };
    case CREATE_DEPLOYMENT_PROFILE_IS_PENDING:
      return {
        ...state,
        addIsCompleted: false,
        addIsPending: true,
        addIsError: null,
      };

    case CREATE_DEPLOYMENT_PROFILE_IS_ERROR: {
      const indexWithoutId = state.depProfs.findIndex((x: $TSFixMe) => !x.id);

      return {
        ...state,
        depProfs: [...state.depProfs.slice(0, indexWithoutId), ...state.depProfs.slice(indexWithoutId + 1)],
        addIsCompleted: true,
        addIsPending: false,
        addIsError: parseError(action.error.message),
      };
    }

    case ADD_DEPLOYMENT_PROFILE_INLINE:
      return {
        ...state,
        depProfs: state.depProfs.concat(action.depProf),
      };
    case CANCEL_EDITION_INLINE:
      return {
        ...state,
        depProfs: state.depProfs.filter((f: $TSFixMe) => f.id),
      };
    case DEPLOYMENT_PROFILE_LOCAL_CHANGE:
      return {
        ...state,
        depProf: {
          ...state.depProf,
          ...action.param,
        },
      };
    case DEPLOYMENT_PROFILE_CANCEL_LOCAL_CHANGES:
      return {
        ...state,
        depProf: { ...state.depProfOriginal },
      };
    case CANCEL_REGION_INLINE_EDITION:
      return {
        ...state,
        depProf: {
          ...state.depProf,
          deploymentRegions: (state.depProf as $TSFixMe).deploymentRegions.filter((region: $TSFixMe) => region.id),
        },
      };
    case REGION_LOCAL_CHANGE:
      return {
        ...state,
        region: {
          ...state.region,
          ...action.param,
        },
      };
    case CANCEL_REGION_LOCAL_CHANGE:
      return {
        ...state,
        region: {
          ...state.regionOriginal,
        },
      };

    case UPDATE_DEPLOYMENT_PROFILE: {
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
      const indexToUpdate = state.depProfs.findIndex((x) => (x as $TSFixMe).id === action.depProf.id);

      return {
        ...state,
        depProfs: state.depProfs.map((item: $TSFixMe, index: number) => {
          if (index !== indexToUpdate) {
            return item;
          }

          return {
            ...item,
            ...action.depProf,
          };
        }),
        depProf: {
          ...action.depProf,
          deploymentRegions: (state.depProf as $TSFixMe).deploymentRegions,
        },
        depProfOriginal: {
          ...action.depProf,
        },
        editIsCompleted: true,
        editIsPending: false,
        editIsError: null,
      };
    }

    case UPDATE_DEPLOYMENT_PROFILE_IS_PENDING:
      return {
        ...state,
        editIsCompleted: false,
        editIsPending: true,
        editIsError: null,
      };
    case UPDATE_DEPLOYMENT_PROFILE_IS_ERROR:
      return {
        ...state,
        editIsCompleted: false,
        editIsPending: true,
        editIsError: action.error,
      };

    case ADD_REGION: {
      /* NOTE: When adding a region in a specific Deployment Profile I'm also
         updating the list of deployment profiles because its possible
         for the user to add a region and try to create a fleet attached
         to that deployment profile
*/
      const profileIndex = state.depProfs.findIndex((x: $TSFixMe) => x.id === (state.depProf as $TSFixMe).id);
      const newRegions = addNew(action.region, (state.depProf as $TSFixMe).deploymentRegions);

      return {
        ...state,
        depProfs: state.depProfs.map((depProf: $TSFixMe, index: number) => {
          if (index !== profileIndex) {
            return depProf;
          }

          return {
            ...depProf,
            deploymentRegions: newRegions,
          };
        }),
        depProf: {
          ...state.depProf,
          deploymentRegions: newRegions,
        },
        depProfOriginal: {
          ...state.depProfOriginal,
          deploymentRegions: newRegions,
        },
        addRegionIsCompleted: true,
        addRegionIsPending: false,
        addRegionIsError: null,
      };
    }

    case ADD_REGION_IS_PENDING:
      return {
        ...state,
        addRegionIsCompleted: false,
        addRegionIsPending: true,
        addRegionIsError: null,
      };
    case ADD_REGION_IS_ERROR:
      return {
        ...state,
        addRegionIsCompleted: true,
        addRegionIsPending: false,
        addRegionIsError: action.error,
      };

    case UPDATE_REGION: {
      const regionIndexToUpdate = (state.depProf as $TSFixMe).deploymentRegions.findIndex((x: $TSFixMe) => x.id === action.region.id);

      return {
        ...state,
        depProf: {
          ...state.depProf,
          deploymentRegions: (state.depProf as $TSFixMe).deploymentRegions.map((region: $TSFixMe, index: $TSFixMe) => {
            if (index !== regionIndexToUpdate) {
              return region;
            }

            return {
              ...region,
              ...action.region,
            };
          }),
        },
        region: {
          ...state.region,
          ...action.region,
        },
        regionOriginal: {
          ...state.regionOriginal,
          ...action.region,
        },
        editRegionIsCompleted: true,
        editRegionIsPending: false,
        editRegionIsError: null,
      };
    }

    case UPDATE_REGION_IS_PENDING:
      return {
        ...state,
        editRegionIsCompleted: false,
        editRegionIsPending: true,
        editRegionIsError: null,
      };
    case UPDATE_REGION_IS_ERROR:
      return {
        ...state,
        editRegionIsCompleted: false,
        editRegionIsPending: true,
        editRegionIsError: parseError(action.error.message),
      };

    case ADD_LOCATION_TO_REGION: {
      const indexInLocationsToDelete = (state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved.indexOf(action.locationId);

      /* NOTE: If action.index exists I'm updating a region */
      if (Number.isInteger(action.index)) {
        return {
          ...state,
          region: {
            ...state.region,
            i3dDcLocationIds: (state.region as $TSFixMe).i3dDcLocationIds.map((item: $TSFixMe, index: $TSFixMe) => {
              if (index !== action.index) {
                return item;
              }

              return action.locationId;
            }),
            i3dDcLocationIdsToBeRemoved:
              indexInLocationsToDelete !== -1
                ? [
                    ...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved.slice(0, indexInLocationsToDelete),
                    ...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved.slice(indexInLocationsToDelete + 1),
                  ]
                : [...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved],
          },
        };
      }

      return {
        ...state,
        region: {
          ...state.region,
          i3dDcLocationIds: (state.region as $TSFixMe).i3dDcLocationIds.concat(action.locationId),
          i3dDcLocationIdsToBeRemoved:
            indexInLocationsToDelete !== -1
              ? [
                  ...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved.slice(0, indexInLocationsToDelete),
                  ...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved.slice(indexInLocationsToDelete + 1),
                ]
              : [...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved],
        },
      };
    }

    case REMOVE_LOCATION_FROM_REGION: {
      const locationToDeleteIndex = (state.regionOriginal as $TSFixMe).i3dDcLocationIds.indexOf(action.locationId);

      if (locationToDeleteIndex !== -1) {
        return {
          ...state,
          region: {
            ...state.region,
            i3dDcLocationIds: [
              ...(state.region as $TSFixMe).i3dDcLocationIds.slice(0, action.index),
              ...(state.region as $TSFixMe).i3dDcLocationIds.slice(action.index + 1),
            ],
            i3dDcLocationIdsToBeRemoved: (state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved.concat(action.locationId),
          },
        };
      }

      return {
        ...state,
        region: {
          ...state.region,
          i3dDcLocationIds: [
            ...(state.region as $TSFixMe).i3dDcLocationIds.slice(0, action.index),
            ...(state.region as $TSFixMe).i3dDcLocationIds.slice(action.index + 1),
          ],
        },
      };
    }

    case CANCEL_LOCATION_TO_REGION: {
      const indexOfUndefinedLocations = (state.region as $TSFixMe).i3dDcLocationIds.indexOf(undefined);

      if (indexOfUndefinedLocations === -1) {
        return {
          ...state,
          region: {
            ...state.region,
            i3dDcLocationIds: [...(state.region as $TSFixMe).i3dDcLocationIds],
            i3dDcLocationIdsToBeRemoved: [...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved],
          },
        };
      }

      return {
        ...state,
        region: {
          ...state.region,
          i3dDcLocationIds: [
            ...(state.region as $TSFixMe).i3dDcLocationIds.slice(0, indexOfUndefinedLocations),
            ...(state.region as $TSFixMe).i3dDcLocationIds.slice(indexOfUndefinedLocations + 1),
          ],
          i3dDcLocationIdsToBeRemoved: [...(state.region as $TSFixMe).i3dDcLocationIdsToBeRemoved],
        },
      };
    }

    case ADD_CONTAINER:
      return {
        ...state,
        region: {
          ...state.region,
          containers: (state.region as $TSFixMe).containers.concat({
            markedForDeletion: false,
            containerLocations: [],
          }),
        },
      };
    case DELETE_CONTAINER:
      if (!action.containerId) {
        return {
          ...state,
          region: {
            ...state.region,
            containers: [
              ...(state.region as $TSFixMe).containers.slice(0, action.position),
              ...(state.region as $TSFixMe).containers.slice(action.position + 1),
            ],
          },
          deleteContainerIsCompleted: true,
          deleteContainerIsPending: false,
          deleteContainerIsError: null,
        };
      }

      if (action.status === 200) {
        return {
          ...state,
          region: {
            ...state.region,
            containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, index: $TSFixMe) => {
              if (index !== action.position) {
                return container;
              }

              return {
                ...container,
                markedForDeletion: 1,
              };
            }),
          },
          regionOriginal: {
            ...state.regionOriginal,
            containers: (state.regionOriginal as $TSFixMe).containers.map((container: $TSFixMe, index: $TSFixMe) => {
              if (index !== action.position) {
                return container;
              }

              return {
                ...container,
                markedForDeletion: 1,
              };
            }),
          },
          deleteContainerIsCompleted: true,
          deleteContainerIsPending: false,
          deleteContainerIsError: null,
        };
      }

      return {
        ...state,
        region: {
          ...state.region,
          containers: [
            ...(state.region as $TSFixMe).containers.slice(0, action.position),
            ...(state.region as $TSFixMe).containers.slice(action.position + 1),
          ],
        },
        regionOriginal: {
          ...state.regionOriginal,
          containers: [
            ...(state.regionOriginal as $TSFixMe).containers.slice(0, action.position),
            ...(state.regionOriginal as $TSFixMe).containers.slice(action.position + 1),
          ],
        },
        deleteContainerIsCompleted: true,
        deleteContainerIsPending: false,
        deleteContainerIsError: null,
      };
    case DELETE_CONTAINER_IS_PENDING:
      return {
        ...state,
        deleteContainerIsCompleted: false,
        deleteContainerIsPending: true,
        deleteContainerIsError: null,
      };
    case DELETE_CONTAINER_IS_ERROR:
      return {
        ...state,
        deleteContainerIsCompleted: true,
        deleteContainerIsPending: false,
        deleteContainerIsError: action.error,
      };

    case CANCEL_DELETE_CONTAINER:
      return {
        ...state,
        region: {
          ...state.region,
          containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, index: $TSFixMe) => {
            if (index !== action.position) {
              return container;
            }

            return {
              ...container,
              markedForDeletion: 0,
            };
          }),
        },
        regionOriginal: {
          ...state.regionOriginal,
          containers: (state.regionOriginal as $TSFixMe).containers.map((container: $TSFixMe, index: $TSFixMe) => {
            if (index !== action.position) {
              return container;
            }

            return {
              ...container,
              markedForDeletion: 0,
            };
          }),
        },
        cancelDeleteContainerIsCompleted: true,
        cancelDeleteContainerIsPending: false,
        cancelDeleteContainerIsError: null,
      };
    case CANCEL_DELETE_CONTAINER_IS_PENDING:
      return {
        ...state,
        cancelDeleteContainerIsCompleted: false,
        cancelDeleteContainerIsPending: true,
        cancelDeleteContainerIsError: null,
      };
    case CANCEL_DELETE_CONTAINER_IS_ERROR:
      return {
        ...state,
        cancelDeleteContainerIsCompleted: true,
        cancelDeleteContainerIsPending: false,
        cancelDeleteContainerIsError: action.error,
      };
    case ADD_CONTAINER_LOCATION:
      return {
        ...state,
        region: {
          ...state.region,
          containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, index: $TSFixMe) => {
            if (index !== action.containerIndex) {
              return container;
            }

            return {
              ...container,
              containerLocations: container.containerLocations.concat({
                markedForDeletion: 0,
              }),
            };
          }),
        },
      };
    case SAVE_CONTAINER_LOCATION:
      return {
        ...state,
        region: {
          ...state.region,
          containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, index: $TSFixMe) => {
            if (index !== action.containerIndex) {
              return container;
            }

            return {
              ...container,
              containerLocations: container.containerLocations.map((location: $TSFixMe, indexLoc: $TSFixMe) => {
                if (indexLoc !== action.index) {
                  return location;
                }

                return {
                  ...location,
                  ...action.model,
                };
              }),
            };
          }),
        },
      };

    case CANCEL_LOCATION_FROM_CONTAINER: {
      const hasAnId = (state.region as $TSFixMe).containers[action.containerIndex].containerLocations[action.index].id || false;

      if (!hasAnId) {
        return {
          ...state,
          region: {
            ...state.region,
            containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, index: $TSFixMe) => {
              if (index !== action.containerIndex) {
                return container;
              }

              return {
                ...container,
                containerLocations: [
                  ...state.region.containers[action.containerIndex].containerLocations.slice(0, action.index),
                  ...state.region.containers[action.containerIndex].containerLocations.slice(action.index + 1),
                ],
              };
            }),
          },
        };
      }

      return {
        ...state,
      };
    }

    case DELETE_REGION: {
      /* NOTE: When REMOVING a region in a specific Deployment Profile I'm also
         updating the list of deployment profiles because its possible
         for the user to add a region and try to create a fleet attached
         to that deployment profile
*/

      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
      const profileIndex = state.depProfs.findIndex((x) => (x as $TSFixMe).id === (state.depProf as $TSFixMe).id);
      const indexRegionToDelete = (state.depProf as $TSFixMe).deploymentRegions.findIndex((region: $TSFixMe) => region.id === action.regionId);

      if (action.status === 200) {
        const newRegions = (state.depProf as $TSFixMe).deploymentRegions.map((region: $TSFixMe, index: $TSFixMe) => {
          if (index !== indexRegionToDelete) {
            return region;
          }

          return {
            ...region,
            markedForDeletion: 1,
          };
        });

        return {
          ...state,
          depProf: {
            ...state.depProf,
            deploymentRegions: newRegions,
          },
          depProfOriginal: {
            ...state.depProfOriginal,
            deploymentRegions: newRegions,
          },
          deleteRegionIsCompleted: true,
          deleteRegionIsPending: false,
          deleteRegionIsError: null,
        };
      }

      const newRegions = [
        ...(state.depProf as $TSFixMe).deploymentRegions.slice(0, indexRegionToDelete),
        ...(state.depProf as $TSFixMe).deploymentRegions.slice(indexRegionToDelete + 1),
      ];

      return {
        ...state,
        depProfs: state.depProfs.map((depProf: $TSFixMe, index: number) => {
          if (index !== profileIndex) {
            return depProf;
          }

          return {
            ...depProf,
            deploymentRegions: newRegions,
          };
        }),
        depProf: {
          ...state.depProf,
          deploymentRegions: newRegions,
        },
        depProfOriginal: {
          ...state.depProfOriginal,
          deploymentRegions: newRegions,
        },
        deleteRegionIsCompleted: true,
        deleteRegionIsPending: false,
        deleteRegionIsError: null,
      };
    }

    case DELETE_REGION_IS_PENDING:
      return {
        ...state,
        deleteRegionIsCompleted: false,
        deleteRegionIsPending: true,
        deleteRegionIsError: null,
      };

    case CANCEL_DELETE_REGION: {
      const indexRegionToDelete = (state.depProf as $TSFixMe).deploymentRegions.findIndex((region: $TSFixMe) => region.id === action.regionId);

      return {
        ...state,
        depProf: {
          ...state.depProf,
          deploymentRegions: (state.depProf as $TSFixMe).deploymentRegions.map((region: $TSFixMe, index: $TSFixMe) => {
            if (index !== indexRegionToDelete) {
              return region;
            }

            return {
              ...region,
              markedForDeletion: 0,
            };
          }),
        },
        depProfOriginal: {
          ...state.depProfOriginal,
          deploymentRegions: (state.depProfOriginal as $TSFixMe).deploymentRegions.map((region: $TSFixMe, index: $TSFixMe) => {
            if (index !== indexRegionToDelete) {
              return region;
            }

            return {
              ...region,
              markedForDeletion: 1,
            };
          }),
        },
        cancelDeleteRegionIsCompleted: true,
        cancelDeleteRegionIsPending: false,
        cancelDeleteRegionIsError: null,
      };
    }

    case CANCEL_DELETE_REGION_IS_PENDING:
      return {
        ...state,
        cancelDeleteRegionIsCompleted: false,
        cancelDeleteRegionIsPending: true,
        cancelDeleteRegionIsError: null,
      };
    case CANCEL_DELETE_REGION_IS_ERROR:
      return {
        ...state,
        cancelDeleteRegionIsCompleted: true,
        cancelDeleteRegionIsPending: false,
        cancelDeleteRegionIsError: action.error,
      };

    case DELETE_DEPLOYMENT_PROFILE: {
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'x' implicitly has an 'any' type.
      const indexToDelete = state.depProfs.findIndex((x) => (x as $TSFixMe).id === action.depProf.id);

      if (action.status === 200) {
        return {
          ...state,
          depProfs: state.depProfs.map((depProf: $TSFixMe, index: number) => {
            if (index !== indexToDelete) {
              return depProf;
            }

            return {
              ...depProf,
              markedForDeletion: 1,
            };
          }),
          deleteIsCompleted: true,
          deleteIsPending: false,
          deleteIsError: null,
        };
      }

      return {
        ...state,
        depProfs: [...state.depProfs.slice(0, indexToDelete), ...state.depProfs.slice(indexToDelete + 1)],
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: null,
      };
    }

    case DELETE_DEPLOYMENT_PROFILE_IS_PENDING:
      return {
        ...state,
        deleteIsCompleted: false,
        deleteIsPending: true,
        deleteIsError: null,
      };
    case DELETE_DEPLOYMENT_PROFILE_IS_ERROR:
      return {
        ...state,
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: parseError(action.error.message),
      };

    case CANCEL_DELETE_DEPLOYMENT_PROFILE: {
      const indexToUpdate = state.depProfs.findIndex((x: $TSFixMe) => x.id === action.id);

      return {
        ...state,
        depProfs: state.depProfs.map((depProf: $TSFixMe, index: number) => {
          if (index !== indexToUpdate) {
            return depProf;
          }

          return {
            ...depProf,
            markedForDeletion: 0,
          };
        }),
        cancelDeleteIsCompleted: true,
        cancelDeleteIsPending: false,
        cancelDeleteIsError: null,
      };
    }

    case CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_PENDING:
      return {
        ...state,
        cancelDeleteIsCompleted: false,
        cancelDeleteIsPending: true,
        cancelDeleteIsError: null,
      };
    case CANCEL_DELETE_DEPLOYMENT_PROFILE_IS_ERROR:
      return {
        ...state,
        cancelDeleteIsCompleted: true,
        cancelDeleteIsPending: false,
        cancelDeleteIsError: action.error,
      };
    case DELETE_LOCATION:
      if (!action.locationId) {
        return {
          ...state,
          region: {
            ...state.region,
            containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, containerIndex: $TSFixMe) => {
              if (containerIndex !== action.position) {
                return container;
              }

              return {
                ...container,
                containerLocations: [
                  ...state.region.containers[action.position].containerLocations.slice(0, action.rowIndex),
                  ...state.region.containers[action.position].containerLocations.slice(action.rowIndex + 1),
                ],
              };
            }),
          },
          deleteLocationIsCompleted: true,
          deleteLocationIsPending: false,
          deleteLocationIsError: null,
        };
      }

      if (action.status === 200) {
        return {
          ...state,
          region: {
            ...state.region,
            containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, containerIndex: $TSFixMe) => {
              if (containerIndex !== action.position) {
                return container;
              }

              return {
                ...container,
                containerLocations: (state.region as $TSFixMe).containers[action.position].containerLocations.map(
                  (location: $TSFixMe, locationIndex: $TSFixMe) => {
                    if (locationIndex !== action.rowIndex) {
                      return location;
                    }

                    return {
                      ...location,
                      markedForDeletion: 1,
                    };
                  },
                ),
              };
            }),
          },
          regionOriginal: {
            ...state.regionOriginal,
            containers: state.regionOriginal.containers.map((container: $TSFixMe, containerIndex: $TSFixMe) => {
              if (containerIndex !== action.position) {
                return container;
              }

              return {
                ...container,
                containerLocations: (state.regionOriginal as $TSFixMe).containers[action.position].containerLocations.map(
                  (location: $TSFixMe, locationIndex: $TSFixMe) => {
                    if (locationIndex !== action.rowIndex) {
                      return location;
                    }

                    return {
                      ...location,
                      markedForDeletion: 1,
                    };
                  },
                ),
              };
            }),
          },
          deleteLocationIsCompleted: true,
          deleteLocationIsPending: false,
          deleteLocationIsError: null,
        };
      }

      return {
        ...state,
        region: {
          ...state.region,
          containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, containerIndex: $TSFixMe) => {
            if (containerIndex !== action.position) {
              return container;
            }

            return {
              ...container,
              containerLocations: [
                ...state.region.containers[action.position].containerLocations.slice(0, action.rowIndex),
                ...state.region.containers[action.position].containerLocations.slice(action.rowIndex + 1),
              ],
            };
          }),
        },
        regionOriginal: {
          ...state.regionOriginal,
          containers: (state.regionOriginal as $TSFixMe).containers.map((container: $TSFixMe, containerIndex: $TSFixMe) => {
            if (containerIndex !== action.position) {
              return container;
            }

            return {
              ...container,
              containerLocations: [
                ...state.regionOriginal.containers[action.position].containerLocations.slice(0, action.rowIndex),
                ...state.regionOriginal.containers[action.position].containerLocations.slice(action.rowIndex + 1),
              ],
            };
          }),
        },
        deleteLocationIsCompleted: true,
        deleteLocationIsPending: false,
        deleteLocationIsError: null,
      };
    case DELETE_LOCATION_IS_PENDING:
      return {
        ...state,
        deleteLocationIsCompleted: false,
        deleteLocationIsPending: true,
        deleteLocationIsError: null,
      };
    case DELETE_LOCATION_IS_ERROR:
      return {
        ...state,
        deleteLocationIsCompleted: true,
        deleteLocationIsPending: false,
        deleteLocationIsError: parseError(action.error.message),
      };
    case CANCEL_DELETE_LOCATION:
      return {
        ...state,
        region: {
          ...state.region,
          containers: (state.region as $TSFixMe).containers.map((container: $TSFixMe, containerIndex: $TSFixMe) => {
            if (containerIndex !== action.position) {
              return container;
            }

            return {
              ...container,
              containerLocations: (state.region as $TSFixMe).containers[action.position].containerLocations.map(
                (location: $TSFixMe, locationIndex: $TSFixMe) => {
                  if (locationIndex !== action.rowIndex) {
                    return location;
                  }

                  return {
                    ...location,
                    markedForDeletion: 0,
                  };
                },
              ),
            };
          }),
        },
        regionOriginal: {
          ...state.regionOriginal,
          containers: state.regionOriginal.containers.map((container: $TSFixMe, containerIndex: $TSFixMe) => {
            if (containerIndex !== action.position) {
              return container;
            }

            return {
              ...container,
              containerLocations: (state.regionOriginal as $TSFixMe).containers[action.position].containerLocations.map(
                (location: $TSFixMe, locationIndex: $TSFixMe) => {
                  if (locationIndex !== action.rowIndex) {
                    return location;
                  }

                  return {
                    ...location,
                    markedForDeletion: 1,
                  };
                },
              ),
            };
          }),
        },
        cancelDeleteLocationIsCompleted: true,
        cancelDeleteLocationIsPending: false,
        cancelDeleteLocationIsError: null,
      };
    case CANCEL_DELETE_LOCATION_IS_PENDING:
      return {
        ...state,
        cancelDeleteLocationIsCompleted: false,
        cancelDeleteLocationIsPending: true,
        cancelDeleteLocationIsError: null,
      };
    case CANCEL_DELETE_LOCATION_IS_ERROR:
      return {
        ...state,
        cancelDeleteLocationIsCompleted: true,
        cancelDeleteLocationIsPending: false,
        cancelDeleteLocationIsError: action.error,
      };
    case FETCH_DEPLOYMENT_PROFILE_IS_PENDING:
      return {
        ...state,
        fetchIsPending: action.pending,
        fetchIsCompleted: false,
        fetchIsError: null,
      };
    case FETCH_DEPLOYMENT_PROFILE_IS_ERROR:
      return {
        ...state,
        fetchByIdPending: false,
        fetchByIdCompleted: true,
        fetchIsError: parseError(action.error.message),
      };

    case FETCH_REGION_BY_ID:
      return {
        ...state,
        region: { ...action.region },
        regionOriginal: { ...action.region },
        fetchRegionByIdIsCompleted: true,
        fetchRegionByIdIsPending: false,
        fetchRegionByIdIsError: null,
      };

    case FETCH_REGION_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchRegionByIdIsCompleted: false,
        fetchRegionByIdIsPending: true,
        fetchRegionByIdIsError: null,
      };
    case FETCH_REGION_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchRegionByIdIsCompleted: true,
        fetchRegionByIdIsPending: false,
        fetchRegionByIdIsError: action.error,
      };
    case SORT:
      return {
        ...state,
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
        depProfs: sort(state.depProfs, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    case SORT_REGIONS:
      return {
        ...state,
        sortRegionBy: action.params.sortSearchParam,
        sortRegionDirection: state.sortRegionDirection === 'ASC' ? 'DESC' : 'ASC',
        depProf: {
          ...state.depProf,
          deploymentRegions: sort((state.depProf as $TSFixMe).deploymentRegions, {
            // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
            sortBy: action.params.sortSearchParam,
            sortDirection: state.sortRegionDirection === 'ASC' ? 'DESC' : 'ASC',
            sortSearchValue: action.params.sortSearchValue || action.params.value,
          }),
        },
      };
    case CLEAN_ERROR:
      return {
        ...state,
        [action.reducerProperty]: [
          ...state[action.reducerProperty].slice(0, action.errorIndex),
          ...state[action.reducerProperty].slice(action.errorIndex + 1),
        ],
      };
    case 'RESET_REDUCER':
    case 'RESET_DEPLOYMENT_PROFILE_REDUCER':
      return {
        ...INITIAL_STATE,
        ...CRUD_PROPERTIES,
      };
    default:
      return state;
  }
};

export default deploymentProfileReducer;
